import {
    Box,
    FormControl,
    FormLabel,
    Select,
    MenuItem,
    Chip,
    FormHelperText,
} from '@mui/material';

const MultiSelect = ({
    label,
    name,
    value = [],
    onChange,
    options = [],
    disabled = false,
    error,
    required = false,
    onDelete,
    handleChipDelete,
    matchByLabel = false,
    ...props
}) => {
    const handleChange = (event) => {
        const {
            target: { value: selectedValue },
        } = event;
        // Ensure value is always an array and convert to correct type
        const newValue = typeof selectedValue === 'string'
            ? selectedValue.split(',').map(val => matchByLabel ? val : Number(val))
            : selectedValue.map(val => matchByLabel ? val : Number(val));
        // Call onChange with synthetic event and field name
        onChange({ target: { name, value: newValue } }, name);
    };

    // Matching function based on matchByLabel prop
    const findMatchedOption = (selectedValue) => {
        if (matchByLabel) {
            return options.find((opt) => opt.label === selectedValue);
        }
        return options.find((opt) => Number(opt.value) === Number(selectedValue));
    };

    return (
        <>
            <FormControl fullWidth>
                <FormLabel>
                    {label}
                    {required && <span style={{ color: 'red' }}>*</span>}
                </FormLabel>
                <Select
                    multiple
                    id={name}
                    name={name}
                    value={value}
                    onChange={handleChange}
                    disabled={disabled}
                    helperText={error}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                zIndex: 1300,
                                mt: 1,
                                maxHeight: 300,
                            },
                        },
                    }}
                    renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {selected.map((selectedValue) => {
                                const matchedOption = findMatchedOption(selectedValue);
                                return (
                                    <Chip
                                        key={selectedValue}
                                        disabled={disabled}
                                        label={matchedOption ? matchedOption.label : selectedValue}
                                        onMouseDown={(e) => e.stopPropagation()}
                                        onDelete={() => handleChipDelete(selectedValue, name)}
                                    />
                                );
                            })}
                        </Box>
                    )}
                    {...props}
                >
                    {options.map((option) => (
                        <MenuItem
                            key={option.value}
                            value={matchByLabel ? option.label : option.value}
                        >
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
                {error && (
                    <FormHelperText sx={{ color: 'red' }}>{error}</FormHelperText>
                )}

            </FormControl>
        </>
    );
};

export default MultiSelect;